import React, { FC, forwardRef } from "react";
import { Control } from "react-hook-form";

import RadioBase, { RadioProps } from "@/components/ui/Form/Radio/RadioBase";
import RadioControlled from "@/components/ui/Form/Radio/RadioControlled";

interface DynamicInputProps extends RadioProps {
  control?: Control<any>;
}

const Radio = forwardRef<HTMLInputElement, DynamicInputProps>((args, ref) => {
  return <>{args?.control ? <RadioControlled control={args.control} {...args} /> : <RadioBase {...args} />}</>;
});
Radio.displayName = "Radio";
export default Radio;
